import { Typography } from '@mui/material';
import { errorContainerStyles } from './styles';

const NoPageFound = () => (
  <Typography variant="h1" sx={errorContainerStyles}>
    Page Not Found
  </Typography>
);

export default NoPageFound;
